import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSkeletonModule } from 'ngx-skeleton';

import { AiLandingPageComponent } from './ai-landing-page.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    AiLandingPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CarouselModule,
    NgxSkeletonModule,
    SharedModule
  ],
  exports: [
    AiLandingPageComponent
  ]
})
export class AiLandingPageModule { } 